import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';

interface CheckClockLoad {
    active: number;
    createdAt: any;
    employeeNumber: number;
    loadDate: any;
    registerNumber: number;
    sinceDate: any;
    untilDate: any;
    updatedAt: any;
    fileName: string;
    fileUrl: string;
}

interface CheckClockLoadId extends CheckClockLoad {
    id: string;
}

@Injectable()
export class CheckClockLoadService {

    checkClockLoadCollection: AngularFirestoreCollection<CheckClockLoad>;
    checkClockLoads: any;

    checkClockLoadDocument: AngularFirestoreDocument<CheckClockLoadId>;
    checkClockLoad: Observable<CheckClockLoadId>;

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.CHECK_CLOCK_LOAD_COLLECTION;
    }

    postCheckClockLoad(checkClockLoadObject: any) {
        this.checkClockLoadCollection = this.afs.collection(this.collection);

        return this.checkClockLoadCollection.add(checkClockLoadObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
            return docRef.id;
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getCheckClockLoads() {
        this.checkClockLoadCollection = this.afs.collection(this.collection, ref => ref.orderBy('name', 'desc'));

        this.checkClockLoads = this.checkClockLoadCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as CheckClockLoad;

                const loadDate = data.loadDate;
                const sinceDate = data.sinceDate;
                const untilDate = data.untilDate;
                const employeeNumber = data.employeeNumber;
                const registerNumber = data.registerNumber;

                return { id$, loadDate, sinceDate, untilDate, employeeNumber, registerNumber };
            });
        }).map(object => object);

        return this.checkClockLoads;
    }

    getCheckClockLoadsSearch(iSinceDate: any, iUntilDate: any) {
        this.checkClockLoadCollection = this.afs.collection(this.collection,
        ref => ref.where('loadDate', '>=', iSinceDate).where('loadDate', '<=', iUntilDate).orderBy('loadDate', 'desc'));

        this.checkClockLoads = this.checkClockLoadCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as CheckClockLoad;

                const loadDate = data.loadDate;
                const sinceDate = data.sinceDate;
                const untilDate = data.untilDate;
                const employeeNumber = data.employeeNumber;
                const registerNumber = data.registerNumber;

                return { id$, loadDate, sinceDate, untilDate, employeeNumber, registerNumber };
            });
        }).map(object => object);

        return this.checkClockLoads;
    }

    getCheckClockLoad(id$: string) {
        this.checkClockLoadDocument = this.afs.doc(this.collection + '/' + id$);

        this.checkClockLoad = this.checkClockLoadDocument.valueChanges();

        return this.checkClockLoad.map(object => object);
    }

    putCheckClockLoad(checkClockLoadObject: any, id$: string) {
        this.checkClockLoadCollection = this.afs.collection(this.collection);

        return this.checkClockLoadCollection.doc(id$).update(checkClockLoadObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    delCheckClockLoad(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        this.checkClockLoadDocument = this.afs.doc(this.collection + '/' + id$);

        return this.checkClockLoadDocument .delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }

}
